<template>
  <div class="item-container row">
    <template v-if="printStatus === 'FAILED'">
      <h2 class="center">
        {{ $t('general.label') }}
        {{ $t('pharmacy.nothingMessage') }}
      </h2>
    </template>
    <template v-else-if="printStatus === 'PRINTED'">
      <div class="medical-label" v-for="(prescription, index) in consultation.order" :key="index">
        <div class="medical-label-container" v-if="hasMedicineToPrint(prescription)">
          <div class="flex-container">
            <div class="times-day-info">
              <p class="times-day-en">
                <u>&nbsp;&nbsp;{{ prescription.totalDays }}&nbsp;&nbsp;</u> DAY/S, <u>&nbsp;&nbsp;{{
                  prescription.packagePerDay }}&nbsp;&nbsp;</u> TIME/S A DAY
              </p>
              <p class="times-day">
                <u>&nbsp;&nbsp;{{ prescription.totalDays }}&nbsp;&nbsp;</u> 日份, 每天 <u>&nbsp;&nbsp;{{
                  prescription.packagePerDay }}&nbsp;&nbsp;</u> 次
              </p>
            </div>
            <div class="text-right warning-message">
              <p>
                KEEP AWAY FROM CHILDREN
              </p>
              <p>
                小心放置, 以免儿童误服
              </p>
            </div>
            <div>
              <v-icon name="exclamation-triangle" scale="0.8em"/>
            </div>
          </div>

          <div class="text-center patient-name">
            {{ consultation.patient.name }}
          </div>
          <div class="text-uppercase light-word text-center">
            {{ visitDate }} MAKUANG@{{ clinicName }}
          </div>

          <div class="flex-container-body">
            <div class="label-header-take">
              <div class="text-uppercase light-word take-before">
                <p class="text-center">
                  TAKE BEFORE
                </p>
                <p class="text-center">
                  饭前
                </p>
              </div>
              <div class="text-uppercase light-word take-after">
                <p class="text-center">
                  AFTER FOOD
                </p>
                <p class="text-center">
                  饭后
                </p>
              </div>
            </div>
            <!-- <span class="vertical-line"></span> -->
            <div class="label-header-time">
              <div class="text-uppercase light-word morning">
                <p class="text-center">
                  MORNING
                </p>
                <p class="text-center">
                  早上
                </p>
              </div>
              <div class="text-uppercase light-word afternoon">
                <p class="text-center">
                  AFTERNOON
                </p>
                <p class="text-center">
                  中午
                </p>
              </div>
              <div class="text-uppercase light-word evening">
                <p class="text-center">
                  EVENING
                </p>
                <p class="text-center">
                  傍晚
                </p>
              </div>
              <div class="text-uppercase light-word night">
                <p class="text-center">
                  NIGHT
                </p>
                <p class="text-center">
                  晚上
                </p>
              </div>
            </div>
          </div>
          <div class="label-body">
            <p class="text-center text-uppercase">
              <span class="light-word"> WITH WARM WATER,AVOID COFFEE,TEA,ALCOHOLIC DRINKS</span>
              <span class="bolder"> &nbsp;温水冲服, 避免与咖啡, 茶, 酒同服</span>
            </p>
            <p class="text-center text-uppercase">
              <span class="light-word"> SEPARATE FROM WESTERN MEDICINE WITH 1-2 HOURS APART</span>
              <span class="bolder">&nbsp;与西药间隔1-2小时服用</span>
            </p>
          </div>
          <div class="label-footer text-center">
            <p>  {{ generalConfig.address }} Tel: {{ generalConfig.telephone }} </p>
          </div>
          <div class="page-break" v-if="index !== (withItemsPrescriptions.length - 1)"></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import constant from '@/services/constant';

const { PRINT_STATUS } = constant;

export default {
  name: 'MakuangMedicalLabelRecord',
  props: {
    consultation: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: String,
      default: PRINT_STATUS.PRINTING,
    },
  },
  computed: {
    ...mapGetters('patient', ['selectedPatient']),
    ...mapGetters('config', { generalConfig: 'general' }),
    visitDate() {
      return this.consultation && moment(this.consultation.visitDate).format('DD/MM/YYYY');
    },
    clinicName() {
      if (this.consultation.clinic.name && this.consultation.clinic.name.split('-').length > 0) {
        return this.consultation.clinic.name.split('-')[1].trim();
      }
      return '';
    },
    printStatus() {
      return this.status;
    },
    withItemsPrescriptions() {
      const result = this.consultation.order.filter(prescription => prescription.items.filter(x => x.inventory !== 'Consultation').length > 0);
      return result;
    },
  },
  methods: {
    hasMedicineToPrint(prescription) {
      return prescription.items.filter(x => x.inventory !== 'Consultation').length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-label-container {
  width: 3.5in;;
  height: 1.42in;
  padding: 1em 0 0.2em 1.2em;
}
.item-container {
  font-size: 0.4em;
  font-weight: bold;
  width: 3.5in;;
  height: 1.42in;
  & > * {
    font-family: Arial, Helvetica, sans-serif;
  }
  #main {
    margin: 0;
    padding: 0;
    min-height: 100%;
  }
}

.flex-container {
  display: flex;
  justify-content: space-between;
}

.vertical-line {
  border-left: 0.1em solid #000;
  margin: 0;
  height: 100%;
}


.flex-container-body > div {
    display: flex;
    justify-content: space-between;
    text-align: center;
}

.flex-container-body > div,
.label-header-take > div,
.label-header-time > div {
    flex: 1;
}

.label-header-take, .label-header-time{
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.label-header-take > .take-before,
.label-header-time > .morning,
.label-header-time > .afternoon,
.label-header-time > .evening {
    border-right: 0.2em solid #000;
    margin: 0.1em 0;
}

.label-header-take > .take-after {
  border-right: 0.1em solid #000;
}

.times-day-info,
.warning-message {
  flex-basis: 45%;
}

.flex-container-body {
    display: flex;
    justify-content: space-between;
    border-top: 0.1em solid #000;
    border-bottom: 0.1em solid #000;
    margin-top: 1em;
}

.warning-message {
  font-size: 1em;
  font-weight: bolder;
}

.label-body {
  border-bottom: 0.1em solid #333;
  margin-left: 0;
  margin-right: 0;
  padding: 0.2em 0;
}

.patient-name {
  font-size: 2.5em;
  font-weight: bolder;
}

.page-break {
  page-break-after: always;
}

p {
  margin-bottom: 0 !important;
}

@page {
  margin: 0;
  padding: 0;
  size: 3.5in 1.42in;
}

// .container-fluid {
//   /* must keep padding for remove padding for label */
//   padding: 0;
// }

</style>

<style lang="scss">
@media print {
  html,
  body {
    height: 99%;
  }

  .medical-label-container {
    zoom: 1.35 !important;
  }
}</style>
